import { render, staticRenderFns } from "./emptyFeedStatus.vue?vue&type=template&id=669ce424&scoped=true&"
import script from "./emptyFeedStatus.vue?vue&type=script&lang=ts&"
export * from "./emptyFeedStatus.vue?vue&type=script&lang=ts&"
import style0 from "./emptyFeedStatus.vue?vue&type=style&index=0&id=669ce424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ce424",
  null
  
)

export default component.exports